import { inject } from "@angular/core"
import { CanActivateFn, Router } from "@angular/router"
import { AuthService } from "../services/auth.service"
import { UserRole } from "../models/auth"

// If not logged in, redirect to login
export const authGuard: (roles: UserRole[]) => CanActivateFn = (roles: UserRole[]) => {
	return (_route, state) => {
		const auth = inject(AuthService)
		const router = inject(Router)

		const url = state.url.split("?")[0]

		if (!auth.isAuthenticated()) {
			// If already on login, allow
			if (url === "/") return true
			router.navigate([""])
			return false
		}
		if (!auth.checkRolePermission(roles)) {
			// If already on workgroups, allow
			if (url === "/workgroups") return true
			router.navigate(["/workgroups"])
			return false
		}

		return true
	}
}

// If logged in, redirect to workgroups
export const loginGuard: CanActivateFn = (_route, state) => {
	const auth = inject(AuthService)
	const router = inject(Router)
	const url = state?.url?.split("?")[0] ?? "/"
	if (auth.isAuthenticated()) {
		// If already on workgroups, allow
		if (url === "/workgroups") return true
		router.navigate(["/workgroups"])
		return false
	}
	return true
}
